<app-title-bar></app-title-bar>

<app-splash></app-splash>

<div style="height: 60px"></div>
<app-card-face-selection></app-card-face-selection>
<app-sdk-run></app-sdk-run>
